export const REGISTRATION_FLOW = Object.freeze({
  /** `onboarding/continue` is the entry point since we are leveraging legacy endpoint redirects.
   * We will be able to change this only after we stop depending on the current backend
   * implementation for determining when to redirect athletes back to the onboarding flow.
   *
   * See OnboardingController#continue
   * */
  createProfile: 'continue',
  suggestedFriends: 'suggested_friends',
  facebookFriends: 'facebook_friends',
  welcome: 'welcome_to_strava', // onboarding/welcome url is already being used by the legacy flow
  subscriptionTrial: 'subscription_trial',
  directPromotion: 'direct_promotion'
});

export const CONSENTS_FLOW = Object.freeze({
  welcome: 'welcome',
  termsOfService: 'terms_of_service',
  privacyPolicy: 'privacy_policy',
  directPromotion: REGISTRATION_FLOW.directPromotion, // shared step
  health: 'health',
  health_denial_one: 'health_denial_one',
  health_denial_two: 'health_denial_two',
  all_set: 'all_set',
  age_confirmation: 'age_confirmation'
});

export const CATEGORIES = Object.freeze({
  onboarding: 'onboarding',
  consents: 'consents'
});

export const INPUT_IDS = Object.freeze({
  firstName: 'firstName',
  lastName: 'lastName',
  birthday: 'birthday',
  month: 'month',
  day: 'day',
  year: 'year',
  gender: 'gender'
});

export default { REGISTRATION_FLOW, CONSENTS_FLOW };
